import React from 'react'

const Denied = () => {
  
    const Banner = {
        backgroundImage: 'url("/denied.jpg")',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        height: '100vh'
    }

    return (
        
        <div className='WideBanner' style={ Banner }>

            <p id='Denied'>You are not autholized!</p>

        </div>
    )

}

export default Denied


// WEBPACK FOOTER //
// ./src/components/etc/Denied.js